import { Monitor, Globe, Shield } from 'lucide-react';
import IndonesiaServiceCard from './IndonesiaServiceCard';

interface IndonesiaServicesGridProps {
  onGetFreeAccess: () => void;
}

const IndonesiaServicesGrid = ({ onGetFreeAccess }: IndonesiaServicesGridProps) => {
  const services = [
    {
      icon: Monitor,
      flag: "🇺🇸",
      title: "Remote Desktop AS",
      subtitle: "US Residential Remote Desktop",
      features: [
        "Desktop AS berkecepatan tinggi • High-speed US desktops",
        "Akses 24/7 tanpa henti • Always-on access",
        "Sempurna untuk freelancer & otomasi • Perfect for automation"
      ],
      color: "red" as const
    },
    {
      icon: Globe,
      flag: "🇺🇸",
      title: "Proxy Residensial AS",
      subtitle: "US Residential Proxies",
      features: [
        "IP bersih dan terpercaya • Clean IPs",
        "Tingkat pemblokiran rendah • Low block rates",
        "Ideal untuk scraping & SEO"
      ],
      color: "orange" as const
    },
    {
      icon: Shield,
      flag: "🇺🇸",
      title: "VPN Residensial AS",
      subtitle: "US Residential VPN",
      features: [
        "100% IP Residensial • 100% Residential IPs",
        "Tanpa log, tanpa throttling • No logs, no throttling",
        "Lewati geo-block & tetap anonim • Bypass geo-blocks"
      ],
      color: "rose" as const
    }
  ];

  return (
    <div className="grid md:grid-cols-3 gap-6 mb-6">
      {services.map((service, index) => (
        <IndonesiaServiceCard
          key={index}
          icon={service.icon}
          flag={service.flag}
          title={service.title}
          subtitle={service.subtitle}
          features={service.features}
          color={service.color}
          onGetFreeAccess={onGetFreeAccess}
        />
      ))}
    </div>
  );
};

export default IndonesiaServicesGrid;
